import { render, staticRenderFns } from "./TaskCommCd.vue?vue&type=template&id=00a655f8&"
import script from "./TaskCommCd.vue?vue&type=script&lang=js&"
export * from "./TaskCommCd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports